import React, { useContext } from 'react';
import { AxiosInstance } from 'axios';

export type NetworkClient = (key: string) => AxiosInstance;

export type NetworkProviderState = { getClient: NetworkClient | undefined };
const NetworkContext = React.createContext<NetworkProviderState>({
  getClient: undefined
});

const useNetwork = (): NetworkProviderState => useContext(NetworkContext);

const API_UCF = 'api-ucf';
const API_PARDOT = 'pardot-api';

export { useNetwork, API_UCF, API_PARDOT };
export default NetworkContext;
